import Request from './baseRequest'

const getUserToken = () => {
  const currentUser = localStorage.getItem('auth.currentUser')
  if (!currentUser) {
    return null
  }
  return JSON.parse(currentUser).token
}

const buildAuthConfig = () => {
  const token = getUserToken()
  return {
    headers: {
      authorization: `Bearer ${token}`,
    },
  }
}

const _createSearchLogsExport = (params, body = {}) => {
  const config = buildAuthConfig()

  return Request.post(
    `${window.config.VUE_APP_BACKEND}/api/analytics/search/logs-export?${params}`,
    body,
    config
  )
}

const _getSearchLogsExports = (params) => {
  const config = buildAuthConfig()

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/search/logs-export?${params}`,
    config
  )
}

const _getSearchLogsExportById = (id) => {
  const config = buildAuthConfig()

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/search/logs-export/${id}`,
    config
  )
}

const _deleteSearchLogsExport = (id) => {
  const config = buildAuthConfig()

  return Request.delete(
    `${window.config.VUE_APP_BACKEND}/api/analytics/search/logs-export/${id}`,
    config
  )
}

const _createItemsExport = (params, payload) => {
  const config = buildAuthConfig()

  // Los campos a exportar van en el body: la lista puede ser larga (custom
  // attributes incluidos) y no entra cómoda en la querystring.
  return Request.post(
    `${window.config.VUE_APP_BACKEND}/api/analytics/project/items-export?${params}`,
    payload || {},
    config
  )
}

const _createBroadcastLogsExport = (params) => {
  const config = buildAuthConfig()

  return Request.post(
    `${window.config.VUE_APP_BACKEND}/api/analytics/broadcast/logs-export?${params}`,
    {},
    config
  )
}

const _createBroadcastAttributionsExport = (params) => {
  const config = buildAuthConfig()

  return Request.post(
    `${window.config.VUE_APP_BACKEND}/api/analytics/broadcast/attributions-export?${params}`,
    {},
    config
  )
}

const _createRecoLogsExport = (params) => {
  const config = buildAuthConfig()

  return Request.post(
    `${window.config.VUE_APP_BACKEND}/api/analytics/recommendations/logs-export?${params}`,
    {},
    config
  )
}

const _createInteractionsExport = (params) => {
  const config = buildAuthConfig()

  return Request.post(
    `${window.config.VUE_APP_BACKEND}/api/analytics/project/interactions-export?${params}`,
    {},
    config
  )
}

const _createRecoAttributionsExport = (params) => {
  const config = buildAuthConfig()

  return Request.post(
    `${window.config.VUE_APP_BACKEND}/api/analytics/recommendations/attributions-export?${params}`,
    {},
    config
  )
}

export default {
  createSearchLogsExport: _createSearchLogsExport,
  getSearchLogsExports: _getSearchLogsExports,
  getSearchLogsExportById: _getSearchLogsExportById,
  deleteSearchLogsExport: _deleteSearchLogsExport,
  createItemsExport: _createItemsExport,
  createBroadcastLogsExport: _createBroadcastLogsExport,
  createBroadcastAttributionsExport: _createBroadcastAttributionsExport,
  createRecoLogsExport: _createRecoLogsExport,
  createInteractionsExport: _createInteractionsExport,
  createRecoAttributionsExport: _createRecoAttributionsExport,
}

